type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

export const PIXEL_IDS = ["2518019921972507", "2252258382314330"];
export const CHECKOUT_URL = "https://musician-master.impultienda.ar/checkout";

export function initPixel() {
  if (typeof window === "undefined" || window.fbq) return;
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) fbq.callMethod(...args);
    else fbq.queue.push(args);
  } as Fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  PIXEL_IDS.forEach((id) => fbq("init", id));
  fbq("track", "PageView");
}

export function trackEvent(event: string, params?: Record<string, unknown>) {
  window.fbq?.("track", event, params);
}

export function goToCheckout() {
  trackEvent("InitiateCheckout", { value: 27, currency: "USD", content_name: "Le Maître de la Guitare - 2 livres + 5 bonus" });
  window.setTimeout(() => {
    window.location.href = CHECKOUT_URL;
  }, 150);
}
